import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 340,
      md: 640,
      lg: 900
    },
    scrollBarWidth: 0
  },
  theme: {
    themes: {
      light: {
        primary: '#34b233',
        secondary: '#777',
        accent: '#ff5722',
        success: '#3adb76',
        warning: '#ffae00',
        alert: '#ec5840',
        primaryDarken: '#258025',
        wanted: '#00bcd4',
        wantedDarken: '#00838F',
        lend: '#ff9800',
        lendDarken: '#ef6c00',
        borrow: '#673AB7',
        borrowDarken: '#311B92',
        offer: '#ff5722',
        offerDarken: '#d84315',
        rejected: '#a16122',
        delete: '#dc143c',
        deleteDarken: '#800000',
        'bg-light-gray': '#ede7de',
        'bg-medium-gray': '#d4cfc7',
        'bg-dark-gray': '#bab6af'
      }
    }
  }
})

export default vuetify
